import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { environment } from 'environments/environment';
import { Moment } from 'moment';
import * as moment from 'moment';
import { Title } from '@angular/platform-browser';
import { UserUpdateRequest, AddedProfileHelper, CityProfile } from '../shared/objects/cities';
import { PublicCityProfileService } from 'app/public/city-profile/city-profile.service';
import { FormCityProfileService } from './form-cityProfile.service';


@Component({
  selector: 'app-form-cityprofile',
  templateUrl: './form-cityProfile.component.html',
  styleUrls: ['./form-cityProfile.component.scss', '../../form-pages.scss']
})
export class FormCityProfileComponent implements OnInit {
  public indicatorForm: UserUpdateRequest = new UserUpdateRequest;
  public success: boolean;
  public btnDisable: boolean;
  public submitted: boolean;
  public indicatorsList: AddedProfileHelper = new AddedProfileHelper();
  public uuId: string;
  public cityId: string;
  profile: CityProfile = new CityProfile;

  constructor(
    public router: Router,
    private title: Title,
    private route: ActivatedRoute,
    private service: FormCityProfileService,
    private cityProfileService: PublicCityProfileService
  ) { }

  ngOnInit() {
    this.profile = new CityProfile();
    document.body.className += ' bgAnother';
    this.title.setTitle('Form Profile City - Bright Cities');
    window.scrollTo(0, 0);
    this.indicatorForm = new UserUpdateRequest();
    this.route.params.subscribe((params: Params) => {
      this.cityId = params['id'];
      this.uuId = params['uuId'];
      this.service.getIndicators(this.cityId, this.uuId).then(result => {
        response => this.indicatorsList = response
        console.log(this.indicatorsList);
        console.log(this.indicatorsList.indicators);
      });
      this.cityProfileService.getCityProfile(this.cityId)
        .then(response => {
          this.profile = response;
        });
    });
    console.log(this.indicatorForm.cityProfile);

  }
  onSubmit() {
    if (!this.btnDisable) {
      this.submitted = true;
      this.btnDisable = true;
      this.service.postIndicators(this.cityId, this.uuId).then(result => {
        this.submitted = false;
        this.btnDisable = false;
        this.success = true;
        this.success = true;
        console.log(this.indicatorForm);
      });
    }
  }

  //anchors
  onClickAnchor(anchor: string) {
    console.log("Anchor: " + anchor);
    let x = document.querySelector('#' + anchor);
    if (x) {
      x.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'start' });
    }
  }
}
